import { render, staticRenderFns } from "./ApaItu.vue?vue&type=template&id=6e494fd2&scoped=true&"
import script from "./ApaItu.vue?vue&type=script&lang=js&"
export * from "./ApaItu.vue?vue&type=script&lang=js&"
import style0 from "./ApaItu.vue?vue&type=style&index=0&id=6e494fd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e494fd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VLayout,VRow,VSkeletonLoader})
